import { N as NcActionButton } from "./chunks/NcActionButton-CVW8aRkE.mjs";
import { N as NcActionButtonGroup } from "./chunks/NcActionButtonGroup-BOr5Of3k.mjs";
import NcActionCaption from "./Components/NcActionCaption.mjs";
import { N as NcActionCheckbox } from "./chunks/NcActionCheckbox-C05ls65i.mjs";
import { N as NcActionInput } from "./chunks/NcActionInput-CoG-fZq9.mjs";
import NcActionLink from "./Components/NcActionLink.mjs";
import { N as NcActionRadio } from "./chunks/NcActionRadio-Bpbs2dPm.mjs";
import NcActionRouter from "./Components/NcActionRouter.mjs";
import { N as NcActions } from "./chunks/NcActions-C832pWHO.mjs";
import NcActionSeparator from "./Components/NcActionSeparator.mjs";
import NcActionText from "./Components/NcActionText.mjs";
import { N as NcActionTextEditable } from "./chunks/NcActionTextEditable-DRwDJjPd.mjs";
import { N as NcAppContent } from "./chunks/NcAppContent-C9NGJE6n.mjs";
import NcAppContentDetails from "./Components/NcAppContentDetails.mjs";
import NcAppContentList from "./Components/NcAppContentList.mjs";
import { N as NcAppNavigation } from "./chunks/NcAppNavigation-DjtmN3dS.mjs";
import { N as NcAppNavigationCaption } from "./chunks/NcAppNavigationCaption-CsoHaLXg.mjs";
import NcAppNavigationIconBullet from "./Components/NcAppNavigationIconBullet.mjs";
import { N as NcAppNavigationItem } from "./chunks/NcAppNavigationItem-DvVYHshm.mjs";
import NcAppNavigationList from "./Components/NcAppNavigationList.mjs";
import { N as NcAppNavigationNew } from "./chunks/NcAppNavigationNew-AiFYSCW1.mjs";
import { N as NcAppNavigationNewItem } from "./chunks/NcAppNavigationNewItem-CdlWkGU3.mjs";
import { N as NcAppNavigationSearch } from "./chunks/NcAppNavigationSearch-CsIzwF6F.mjs";
import { N as NcAppNavigationSettings } from "./chunks/NcAppNavigationSettings-Dq2O3kRz.mjs";
import NcAppNavigationSpacer from "./Components/NcAppNavigationSpacer.mjs";
import { N as NcAppSettingsDialog } from "./chunks/NcAppSettingsDialog-DVFw09eD.mjs";
import NcAppSettingsSection from "./Components/NcAppSettingsSection.mjs";
import { N as NcAppSidebar } from "./chunks/NcAppSidebar-Bda_fc-F.mjs";
import { N as NcAppSidebarHeader } from "./chunks/NcAppSidebarHeader-CBE4tNYb.mjs";
import NcAppSidebarTab from "./Components/NcAppSidebarTab.mjs";
import { N as NcAssistantButton } from "./chunks/NcAssistantButton-Dk28Wilk.mjs";
import NcAssistantContent from "./Components/NcAssistantContent.mjs";
import { N as NcAssistantIcon } from "./chunks/NcAssistantIcon-CtEF1hjA.mjs";
import { N as NcAvatar } from "./chunks/NcAvatar-CuYtFEdJ.mjs";
import { u } from "./chunks/NcAvatar-CuYtFEdJ.mjs";
import { N as NcBlurHash } from "./chunks/NcBlurHash-DZmsBU0q.mjs";
import { N as NcBreadcrumb } from "./chunks/NcBreadcrumb-D1106x4x.mjs";
import { N as NcBreadcrumbs } from "./chunks/NcBreadcrumbs-C9Zo0nca.mjs";
import { N as NcButton } from "./chunks/NcButton-CWPBzbcC.mjs";
import { N as NcCheckboxRadioSwitch } from "./chunks/NcCheckboxRadioSwitch-CLnWsBwK.mjs";
import { N as NcCollectionList } from "./chunks/NcCollectionList-5_ghrfiE.mjs";
import { N as NcColorPicker } from "./chunks/NcColorPicker-Cae6XNoK.mjs";
import { N as NcContent } from "./chunks/NcContent-CGBJ782F.mjs";
import { N as NcCounterBubble } from "./chunks/NcCounterBubble-oxV8oMlX.mjs";
import { N as NcDashboardWidget } from "./chunks/NcDashboardWidget-_Bi63nDZ.mjs";
import { N as NcDashboardWidgetItem } from "./chunks/NcDashboardWidgetItem-D4q57Lg_.mjs";
import { N as NcDateTime } from "./chunks/NcDateTime-enXYuwj8.mjs";
import NcDateTimePicker from "./Components/NcDateTimePicker.mjs";
import NcDateTimePickerNative from "./Components/NcDateTimePickerNative.mjs";
import { N as NcDialog } from "./chunks/NcDialog-Du-BeUCp.mjs";
import { N as NcDialogButton } from "./chunks/NcDialogButton-DtGSMhif.mjs";
import NcEllipsisedOption from "./Components/NcEllipsisedOption.mjs";
import { N as NcEmojiPicker } from "./chunks/NcEmojiPicker-B2SLfIBu.mjs";
import NcEmptyContent from "./Components/NcEmptyContent.mjs";
import NcGuestContent from "./Components/NcGuestContent.mjs";
import { N as NcHeaderButton } from "./chunks/NcHeaderButton-BORaK-yT.mjs";
import { N as NcHeaderMenu } from "./chunks/NcHeaderMenu-CkD6cjnH.mjs";
import { N as NcHighlight } from "./chunks/index-CxTT94_h.mjs";
import { N as NcIconSvgWrapper } from "./chunks/NcIconSvgWrapper-BreCg8pX.mjs";
import { N as NcInputField } from "./chunks/NcInputField-kKgY_2GV.mjs";
import { N as NcListItem } from "./chunks/NcListItem-B3ETbT9w.mjs";
import { N as NcListItemIcon } from "./chunks/NcListItemIcon-bQZej-L0.mjs";
import NcLoadingIcon from "./Components/NcLoadingIcon.mjs";
import NcModal from "./Components/NcModal.mjs";
import NcNoteCard from "./Components/NcNoteCard.mjs";
import { N as NcPasswordField } from "./chunks/NcPasswordField-9LYKS0t_.mjs";
import { N as NcPopover } from "./chunks/NcPopover-DMUA5d7U.mjs";
import { N as NcProgressBar } from "./chunks/NcProgressBar-D7zYeXBH.mjs";
import { N as NcRadioGroup } from "./chunks/NcRadioGroup-VKZJ0Vnh.mjs";
import { N as NcRadioGroupButton } from "./chunks/NcRadioGroupButton-QLL4wM7A.mjs";
import { N as NcRelatedResourcesPanel } from "./chunks/NcRelatedResourcesPanel-jvOEQWWO.mjs";
import { N as NcMentionBubble } from "./chunks/index-TmAR7I2T.mjs";
import { r } from "./chunks/index-TmAR7I2T.mjs";
import { N as NcAutoCompleteResult, a as NcRichContenteditable } from "./chunks/NcRichContenteditable-iQhj1-AH.mjs";
import "@nextcloud/auth";
import "@nextcloud/axios";
import "@nextcloud/router";
import "@nextcloud/sharing/public";
import "@vueuse/core";
import "vue";
import "vue-router";
import { a, g, b, c, s, d } from "./chunks/referencePickerModal-CN4C9eDc.mjs";
import { N, h, c as c2, i, e, r as r2, f, a as a2 } from "./chunks/customPickerElements-DLFtgReB.mjs";
import "unist-builder";
import "unist-util-visit";
import "./chunks/logger-D3RVzcfQ.mjs";
import { N as NcRichText } from "./chunks/NcRichText-B7M7rNqC.mjs";
import { N as NcSelect } from "./chunks/NcSelect-PvjbF3jF.mjs";
import { N as NcTextField } from "./chunks/NcTextField-D_IMz2MR.mjs";
import "@nextcloud/event-bus";
import { N as NcSavingIndicatorIcon } from "./chunks/NcSavingIndicatorIcon-U7AIamCl.mjs";
import { N as NcSelectTags } from "./chunks/NcSelectTags-DYUCDZ_e.mjs";
import { N as NcSelectUsers } from "./chunks/NcSelectUsers-CMF_h9c0.mjs";
import { N as NcSettingsInputText } from "./chunks/NcSettingsInputText-BQVh24zT.mjs";
import { N as NcSettingsSection } from "./chunks/NcSettingsSection-evNvfEg2.mjs";
import { N as NcSettingsSelectGroup } from "./chunks/NcSettingsSelectGroup-C-YAk1f8.mjs";
import { N as NcTextArea } from "./chunks/NcTextArea-DHmD6-6s.mjs";
import { N as NcThemeProvider } from "./chunks/NcThemeProvider-25ResoIv.mjs";
import { N as NcTimezonePicker } from "./chunks/NcTimezonePicker-Cu1FrSIX.mjs";
import { N as NcUserBubble } from "./chunks/NcUserBubble-Be2B8iJY.mjs";
import { N as NcUserStatusIcon } from "./chunks/NcUserStatusIcon-C83nB_8T.mjs";
import NcVNodes from "./Components/NcVNodes.mjs";
import { useFormatDateTime, useFormatRelativeTime, useFormatTime } from "./Composables/useFormatDateTime.mjs";
import { useHotKey } from "./Composables/useHotKey.mjs";
import { useIsDarkTheme, useIsDarkThemeElement } from "./Composables/useIsDarkTheme.mjs";
import { isFullscreenState, useIsFullscreen } from "./Composables/useIsFullscreen.mjs";
import { MOBILE_BREAKPOINT, MOBILE_SMALL_BREAKPOINT, isMobileState, useIsMobile, useIsSmallMobile } from "./Composables/useIsMobile.mjs";
import { isA11yActivation } from "./Functions/a11y.mjs";
import { getEnabledContactsMenuActions, registerContactsMenuAction } from "./Functions/contactsMenu.mjs";
import { spawnDialog } from "./Functions/dialog.mjs";
import { E, a as a3, e as e2, g as g2, s as s2 } from "./chunks/emoji-BY_D0V5K.mjs";
import { checkIfDarkTheme, isDarkTheme } from "./Functions/isDarkTheme.mjs";
import { preloadImage } from "./Functions/preloadImage.mjs";
import { usernameToColor } from "./Functions/usernameToColor.mjs";
import directive from "./Directives/Focus.mjs";
import directive$1 from "./Directives/Linkify.mjs";
import "./Directives/Tooltip.mjs";
import { default as default2 } from "./Mixins/clickOutsideOptions.mjs";
import { default as default3 } from "./Mixins/isFullscreen.mjs";
import { default as default4 } from "./Mixins/isMobile.mjs";
import { VTooltip } from "floating-vue";
import { VTooltip as VTooltip2 } from "floating-vue";
const NcComponents = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes
}, Symbol.toStringTag, { value: "Module" }));
const NcDirectives = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Focus: directive,
  Linkify: directive$1,
  Tooltip: VTooltip
}, Symbol.toStringTag, { value: "Module" }));
const NextcloudVuePlugin = {
  install(Vue) {
    Object.entries(NcComponents).forEach(([name, component]) => {
      Vue.component(component.name || name, component);
    });
    Object.entries(NcDirectives).forEach(([name, directive2]) => {
      Vue.directive(name, directive2);
    });
  }
};
export {
  E as EmojiSkinTone,
  directive as Focus,
  directive$1 as Linkify,
  MOBILE_BREAKPOINT,
  MOBILE_SMALL_BREAKPOINT,
  NcActionButton,
  NcActionButtonGroup,
  NcActionCaption,
  NcActionCheckbox,
  NcActionInput,
  NcActionLink,
  NcActionRadio,
  NcActionRouter,
  NcActionSeparator,
  NcActionText,
  NcActionTextEditable,
  NcActions,
  NcAppContent,
  NcAppContentDetails,
  NcAppContentList,
  NcAppNavigation,
  NcAppNavigationCaption,
  NcAppNavigationIconBullet,
  NcAppNavigationItem,
  NcAppNavigationList,
  NcAppNavigationNew,
  NcAppNavigationNewItem,
  NcAppNavigationSearch,
  NcAppNavigationSettings,
  NcAppNavigationSpacer,
  NcAppSettingsDialog,
  NcAppSettingsSection,
  NcAppSidebar,
  NcAppSidebarHeader,
  NcAppSidebarTab,
  NcAssistantButton,
  NcAssistantContent,
  NcAssistantIcon,
  NcAutoCompleteResult,
  NcAvatar,
  NcBlurHash,
  NcBreadcrumb,
  NcBreadcrumbs,
  NcButton,
  NcCheckboxRadioSwitch,
  NcCollectionList,
  NcColorPicker,
  NcContent,
  NcCounterBubble,
  N as NcCustomPickerRenderResult,
  NcDashboardWidget,
  NcDashboardWidgetItem,
  NcDateTime,
  NcDateTimePicker,
  NcDateTimePickerNative,
  NcDialog,
  NcDialogButton,
  NcEllipsisedOption,
  NcEmojiPicker,
  NcEmptyContent,
  NcGuestContent,
  NcHeaderButton,
  NcHeaderMenu,
  NcHighlight,
  NcIconSvgWrapper,
  NcInputField,
  NcListItem,
  NcListItemIcon,
  NcLoadingIcon,
  NcMentionBubble,
  NcModal,
  NcNoteCard,
  NcPasswordField,
  NcPopover,
  NcProgressBar,
  NcRadioGroup,
  NcRadioGroupButton,
  NcRelatedResourcesPanel,
  NcRichContenteditable,
  NcRichText,
  NcSavingIndicatorIcon,
  NcSelect,
  NcSelectTags,
  NcSelectUsers,
  NcSettingsInputText,
  NcSettingsSection,
  NcSettingsSelectGroup,
  NcTextArea,
  NcTextField,
  NcThemeProvider,
  NcTimezonePicker,
  NcUserBubble,
  NcUserStatusIcon,
  NcVNodes,
  NextcloudVuePlugin,
  VTooltip2 as Tooltip,
  a as anyLinkProviderId,
  checkIfDarkTheme,
  default2 as clickOutsideOptions,
  a3 as emojiAddRecent,
  e2 as emojiSearch,
  g2 as getCurrentSkinTone,
  getEnabledContactsMenuActions,
  g as getLinkWithPicker,
  b as getProvider,
  c as getProviders,
  h as hasInteractiveView,
  isA11yActivation,
  c2 as isCustomPickerElementRegistered,
  isDarkTheme,
  default3 as isFullscreen,
  isFullscreenState,
  default4 as isMobile,
  isMobileState,
  i as isWidgetRegistered,
  preloadImage,
  registerContactsMenuAction,
  e as registerCustomPickerElement,
  r2 as registerWidget,
  f as renderCustomPickerElement,
  a2 as renderWidget,
  r as richEditor,
  s as searchProvider,
  s2 as setCurrentSkinTone,
  d as sortProviders,
  spawnDialog,
  useFormatDateTime,
  useFormatRelativeTime,
  useFormatTime,
  useHotKey,
  useIsDarkTheme,
  useIsDarkThemeElement,
  useIsFullscreen,
  useIsMobile,
  useIsSmallMobile,
  u as userStatus,
  usernameToColor
};
//# sourceMappingURL=index.mjs.map
